import { useTranslation } from 'react-i18next'
import { Badge } from '@agion/ui'
import type { OperationStatus } from '@/core/infra_types'

interface OperationStatusBadgeProps {
  status: OperationStatus
}

const statusVariantMap: Record<OperationStatus, 'default' | 'success' | 'warning' | 'error' | 'info'> = {
  pending: 'default',
  running: 'info',
  completed: 'success',
  succeeded: 'success',
  failed: 'error',
  cancelled: 'warning',
}

export function OperationStatusBadge({ status }: OperationStatusBadgeProps) {
  const { t } = useTranslation(['pages'])
  return (
    <Badge variant={statusVariantMap[status] ?? 'default'}>
      {t(`pages:operations.status.${status}`, status)}
    </Badge>
  )
}
